import { List, Datagrid, TextField,
         FunctionField,
         BooleanField} from 'react-admin';
import Box from '@mui/material/Box';

export const FindingList = props => (
  <List {...props}>
    <Datagrid>
      <TextField source="id"/>
      <TextField source="account_id"/>
      <TextField source="vulnerability_type"/>
      <TextField source="name"/>
      <TextField source="affected_urls" label="Affected Endpoint"/>
      <TextField source="description"/>
      <FunctionField source="payload"
        render={
          record => (
            <Box
              component="pre"
              sx={{
                margin: 0,
                fontFamily: 'inherit',
                whiteSpace: 'pre-wrap',
                wordBreak: 'break-word',
                resize: 'both',
                overflow: 'auto',
                minWidth: '150px',
                maxWidth: '400px',
                minHeight: '1.5em',
                maxHeight: '300px',
                border: '1px solid',
                borderColor: 'divider',
                borderRadius: 1,
                padding: '4px 6px',
              }}
            >
              {record.payload}
            </Box>
          )
        }
      />
      <TextField source="poc_image_path"/>
      <TextField source="severity"/>
      <BooleanField source="used_threat_model"/>
      <TextField source="threat_model_info"/>
      <BooleanField source="used_design_document"/>
      <TextField source="design_document_info"/>
      <FunctionField source="updated_at" 
        render={
          record => {
            return new Date(record.updated_at).toLocaleString(undefined, {timeZoneName: "shortOffset"});
          }
        }
      />
      <TextField source="website_name"/>
    </Datagrid>
  </List>
);